import { useEffect, useState } from "react";
import Button from "@/components/Button";
import Column from "@/components/Column";
import Columns from "@/components/Columns";
import Container from "@/components/Container";
import Text from "@/components/Text";
import Title from "@/components/Title";
import Footer from "@/components/Footer";
import TopBar from "@/components/TopBar";
import api from "@/api";
import SEO from "@/components/SEO";

export const PlanActivation = () => {
  const [responseURL, seResponseURL] = useState<string | null>("");

  useEffect(() => {
    const response = new URLSearchParams(
      document.location.search.substring(1)
    ).get("response");

    seResponseURL(response);

    const id = new URLSearchParams(document.location.search.substring(1)).get(
      "id"
    );

    if (response && response === "Sim") {
      api.put(`/core/impactos/${id}?resposta=Sim`);
    }

    if (response && response === "Nao") {
      api.put(`/core/impactos/${id}?resposta=Não`);
    }
  }, [responseURL]);

  return (
    <div>
      {responseURL && responseURL === "Sim" ? (
        <>
          <SEO
            title="Ativação do Plano"
            description="Parabéns estamos ativando seu plano."
          />

          <TopBar />

          <Columns
            className="mt-4 flex flex-1 flex-col items-center justify-center"
            useNegativeMargin={false}
          >
            <Column size={[12, 8, 4]} className="px-12">
              <Container
                as="main"
                className="mt-4 box-border flex w-80 flex-col items-center justify-center rounded-lg shadow-lg"
              >
                <Title
                  kind="soft-blue"
                  className="w-full rounded-t-lg p-8 text-center"
                >
                  <Text
                    as="span"
                    className="font-normal leading-none"
                    size="2xl"
                  >
                    Estamos ativando o seu plano
                  </Text>
                </Title>

                <Title
                  kind="white"
                  className="w-full rounded-b-lg px-12 py-8 text-center"
                >
                  <Text
                    as="span"
                    className="block font-normal leading-none"
                    size="lg"
                    kind="indigo"
                  >
                    Em breve enviaremos um e-mail confirmando a ativação do seu
                    plano.
                  </Text>
                </Title>

                <Column size={[11]} className="mx-auto pb-8 text-center">
                  <div
                    className="pb-1"
                    style={{ borderTop: "1px solid rgba(0, 0, 0, 0.15)" }}
                  />
                  <Button
                    type="button"
                    className="tim-soft-blue mt-6 text-base font-bold"
                    large
                    style={{ backgroundColor: "#2E82E6" }}
                    to="/"
                  >
                    IR PARA A PÁGINA INICIAL
                  </Button>
                </Column>
              </Container>
            </Column>
          </Columns>

          <Column className="absolute bottom-0 left-0 right-0 mb-4">
            <Footer showText />
          </Column>
        </>
      ) : (
        <>
          <SEO
            title="Ativação do Plano"
            description="Não ativaremos o seu plano."
          />

          <TopBar />

          <Columns
            className="mt-4 flex flex-1 flex-col items-center justify-center"
            useNegativeMargin={false}
          >
            <Column size={[12, 8, 4]} className="px-12">
              <Container
                as="main"
                className="mt-4 box-border flex w-80 flex-col items-center justify-center rounded-lg shadow-lg"
              >
                <Title
                  kind="soft-blue"
                  className="w-full rounded-t-lg p-8 text-center"
                >
                  <Text
                    as="span"
                    className="font-normal leading-none"
                    size="2xl"
                  >
                    Agradecemos a resposta.
                  </Text>
                </Title>

                <Title
                  kind="white"
                  className="w-full rounded-b-lg px-12 py-8 text-center"
                >
                  <Text
                    as="span"
                    className="block font-normal leading-none"
                    size="lg"
                    kind="indigo"
                  >
                    Seu plano nāo será ativado.
                  </Text>
                </Title>

                <Column size={[11]} className="mx-auto pb-8 text-center">
                  <div
                    className="pb-1"
                    style={{ borderTop: "1px solid rgba(0, 0, 0, 0.15)" }}
                  />
                  <Button
                    type="button"
                    className="tim-soft-blue mt-6 text-base font-bold"
                    large
                    style={{ backgroundColor: "#2E82E6" }}
                    to="/"
                  >
                    IR PARA A PÁGINA INICIAL
                  </Button>
                </Column>
              </Container>
            </Column>
          </Columns>

          <Column className="absolute bottom-0 left-0 right-0 mb-4">
            <Footer showText />
          </Column>
        </>
      )}
    </div>
  );
};

export default PlanActivation;
